export default __webpack_public_path__ + "static/media/actividad-4.1a665860.mp3";